const baseUrlPages = (boxId: number) => `/consult/${boxId}/scanned-documents`;
const scannedDocumentsUrls = (boxId: number) => ({
  add: `${baseUrlPages(boxId)}/add`,
  baseUrl: `${baseUrlPages(boxId)}`,
});

export default scannedDocumentsUrls;
